import React from "react";
import logo from "../images/logo3.jpg";

function Header() {
  return (
    <>
      <nav className="navbar navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="curioCodeSolution" className="mainLogo"></img>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasDarkNavbar"
            aria-controls="offcanvasDarkNavbar"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className="offcanvas offcanvas-end text-bg-dark"
            tabIndex={-1}
            id="offcanvasDarkNavbar"
            aria-labelledby="offcanvasDarkNavbarLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasDarkNavbarLabel">
                CurioCode Solutions
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                <li className="nav-item">
                  <a className="nav-link active" aria-current="page" href="/">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link active" href="./Applynow.jsx">
                    Apply for Intership
                  </a>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#alldomain"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Courses
                  </a>
                  <ul className="dropdown-menu dropdown-menu-dark">
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Web Development
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Android Development
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Machine Learning
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Data Science
                      </a>
                    </li>
                    <li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                          target="_blank"
                          rel="noreferrer"
                        >
                          UI/UX Design
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Artificial Intelligence
                        </a>
                      </li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Java Programming
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Python Programming
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeUkkbg3tRmlTOqyWJprIowdN7iKlo1bmJN4uhO0OVUy4XfEg/viewform"
                        target="_blank"
                        rel="noreferrer"
                      >
                        C++ Programming
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#alldomain"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Jobs
                  </a>
                  <ul className="dropdown-menu dropdown-menu-dark">
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://forms.gle/xZUGa4nSRcQeZvYs9"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Software Tester
                      </a>
                      {/* <span
                        className="position-absolute translate-middle badge rounded-pill bg-danger"
                        style={{ left: "60%", zIndex: "1" }}
                      >
                        Closed
                      </span> */}
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://forms.gle/xZUGa4nSRcQeZvYs9"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Promotion executive{" "}
                      </a>
                      {/* <span
                        className="position-absolute translate-middle text-center badge rounded-pill bg-danger"
                        style={{ left: "60%", zIndex: "1" }}
                      >
                        Closed
                      </span> */}
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://forms.gle/xZUGa4nSRcQeZvYs9"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Campus Ambassador
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="https://forms.gle/xZUGa4nSRcQeZvYs9"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Mentor
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a className="nav-link active" href="./Verification.jsx">
                    Verification
                  </a>
                </li>

                <li className="nav-item">
                  <a className="nav-link active" href="./Aboutus.jsx">
                    About us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link active" href="/#contactus">
                    Contact us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
